import { render, staticRenderFns } from "./DocumentPhotoAdd.vue?vue&type=template&id=c2c8cf20&scoped=true&"
import script from "./DocumentPhotoAdd.vue?vue&type=script&lang=js&"
export * from "./DocumentPhotoAdd.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPhotoAdd.vue?vue&type=style&index=0&id=c2c8cf20&prod&scoped=true&lang=css&"
import style1 from "./DocumentPhotoAdd.vue?vue&type=style&index=1&id=c2c8cf20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c8cf20",
  null
  
)

export default component.exports